import { ReactElement } from "react";
import Spinner from "@brighthr/component-spinner";
import classNames from "classnames";

export type ViewLoadingProps = {
  type?: "default" | "screen";
  label?: string;
  containerClass?: string;
};

const defaultLabel = "processing request";

export const ViewLoading = ({ type = "default", label = defaultLabel, containerClass }: ViewLoadingProps): ReactElement => {
  let heightClass;
  let spinnerClass;
  switch (type) {
    case "screen":
      heightClass = "fixed top-0 left-0 h-screen w-screen z-[9998] bg-[#00000066] pointer-events-none";
      spinnerClass = "relative stroke-white"
      break;
    default:
      spinnerClass = "stroke-primary-700";
      break;
  }
  return (
    <div className={classNames("flex items-center justify-center", heightClass, containerClass)}>
      <Spinner ariaLabel={label} className={spinnerClass} size="xxl" />
    </div>
  );
};

export default ViewLoading;
